import * as React from "react";
import { AiStatusPill } from "./components/ui/AiStatusPill";
import { IconChevronRight } from "./icons";
import { ruleTitle } from "./utils";
import type { RowReviewStatus } from "./utils";
import type { RowWithIndex } from "./types";

export type IssueRowProps = {
  item: RowWithIndex;
  status: RowReviewStatus;
  selected?: boolean;
  focused?: boolean;
  onClick: () => void;
};

export const IssueRow: React.FC<IssueRowProps> = ({
  item,
  status,
  selected,
  focused,
  onClick,
}) => {
  const showStatus =
    !item.row.compliant && (status === "accepted" || status === "rejected");
  const clause = `¶${item.row.index}`;

  return (
    <button
      type="button"
      className={`ai-analysis__issue-row${selected || focused ? " ai-analysis__issue-row--selected" : ""}`}
      onClick={onClick}
    >
      <span className="ai-analysis__issue-title">{ruleTitle(item.row)}</span>
      <span className="ai-analysis__issue-clause" title={clause}>
        {clause}
      </span>
      <span className="ai-analysis__issue-row-trailing">
        {showStatus ? <AiStatusPill variant={status} /> : null}
        <IconChevronRight size={11} />
      </span>
    </button>
  );
};
